<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('menu.new') }}</div>
                <div class="mainBody">
                    <p class="check">{{ $t('meetingS.theme.thead.td1')
                        }}：<span class="bold">{{ $t('meetingS.theme.date') }}</span></p>
                    <p class="check">{{ $t('meetingS.theme.thead.td3')
                        }}：<span class="bold">{{ $t('guest.signin.time444') }}</span></p>
                    <p class="check">{{ $t('meetingS.theme.thead.td2') }}：<span class="bold">{{ sytime }}</span></p>
                    <div class="list" v-if="isOrder == 1">
                        <label :for="'item' + index" class="item" v-for="(item, index) in list" :key="index" :class="item.num == 0 ? 'active1' : sytime == item.title ? 'active' : ''">
                            <input type="radio" :disabled="item.num == 0" :name="'' + index" :id="'item' + index" :value="item.title" v-model="sytime">
                            <div>{{ item.title }}<br><span style="font-size: .24rem;line-height: 1;">( {{ $t('meetingS.theme.thead.td22') }}:{{ item.num < 0 ? 0 : item.num }} )</span></div>
                        </label>
                    </div>
                    <p><input type="submit" v-if="isOrder == 1" :value="$t('investigation1.btn')" id="submit" @click="submit" />
                    </p>
                </div>

                <div class="mainTitle" style="margin-top: .5rem;" v-if="isOrder == 2">{{ $t('menu.new1') }}</div>
                <div class="mainBody" v-if="isOrder == 2">
                    <div class="list1" v-if="questionnaire == 1">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/order.png" alt="">
                        {{ $t('investigation1.thanks') }}
                    </div>
                    <div style="margin:0 auto; font-size:0.27rem;line-height:0.45rem;padding-bottom: .3rem;"
                        v-if="questionnaire == 0">
                        <div>
                            <p>{{ $t('investigation1.tips') }}</p>
                        </div>
                        <br>
                        <div>
                            <p>{{ $t('investigation1.question1') }}</p>
                            <div v-for="(item1, index1) in list1" :key="index1" style="padding:0 .4rem;">
                                <p class="star_tit" style="margin-left: -.2rem;">{{ item1.name }}</p>
                                <div class="star" v-if="!item1.type">
                                    <label :for="item1.val + index" v-for="(index) in 10" :key="index">
                                        <input type="radio" 
                                               :value="index"
                                               v-model="subList[item1.val]" 
                                               :name="item1.val" 
                                               :id="item1.val + index"
                                               style="position: absolute;opacity: 0;left:0;top:0;width:100%;height:100%; padding:0;">
                                        <p :class="subList[item1.val] == index ? 'actives' : 'normal'" @click="setScore(index, item1.val)">
                                            {{ index }}
                                        </p>
                                    </label>
                                </div>
                                <textarea v-if="subList[item1.val] > 0 && subList[item1.val] < 6 && !item1.type" type="text" :name="'qt' + index1" v-model="subList[item1.val + 't']" :placeholder="$t('investigation1.placeholder')" class="textarea_6"></textarea>
                                <div v-if="item1.type == 'input'">
                                    <textarea  type="text" :name="'qt' + index1" v-model="subList[item1.val]"></textarea>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p>{{ $t('investigation1.question2') }}</p>
                            <div v-for="(item1, index1) in list2" :key="index1" style="padding:0 .4rem;">
                                <p class="star_tit" style="margin-left: -.2rem;">{{ item1.name }}</p>
                                <div class="star" v-if="!item1.type">
                                    <label :for="item1.val + index" v-for="(index) in 10" :key="index">
                                        <input type="radio" 
                                               :value="index"
                                               v-model="subList[item1.val]" 
                                               :name="item1.val" 
                                               :id="item1.val + index"
                                               style="position: absolute;opacity: 0;left:0;top:0;width:100%;height:100%; padding:0;">
                                        <p :class="subList[item1.val] == index ? 'actives' : 'normal'" @click="setScore(index, item1.val)">
                                            {{ index }}
                                        </p>
                                    </label>
                                </div>
                                <textarea v-if="subList[item1.val] > 0 && subList[item1.val] < 6 && !item1.type" type="text" :name="'qt' + index1" v-model="subList[item1.val + 't']" :placeholder="$t('investigation1.placeholder')" class="textarea_6"></textarea>
                                <div v-if="item1.type == 'input'">
                                    <textarea  type="text" :name="'qt' + index1" v-model="subList[item1.val]"></textarea>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p>{{ $t('investigation1.question3') }}</p>
                            <p>
                                <textarea v-model="subList['q13']" rows="3" style="max-height:100px; width:100%; border:1px #CCC solid;" id="q10" name="q10" value=""></textarea>
                            </p>
                        </div>
                        <div>
                            <p><input type="submit" :value="$t('investigation1.btn')" id="submit" @click="submit" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path()" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }"> <img
                width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import menus from "../../components/menu.vue"
export default {
    components: {
        menus
    },
    inject: ['reload'],
    name: "menuView",
    data() {
        return {
            sytime: '',
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            toastText: '',
            toastShow: false,
            isOrder: 0,
            list: [],
            list1: [],
            list2: [],
            questionnaire: 2,
            subList: {
                q13: ''
            },
        }
    },
    created() {
        let that = this, data = new FormData();
        that.list1 = that.$t('investigation1.question1Arr');
        that.list2 = that.$t('investigation1.question2Arr');

        // 初始化 subList
        that.list1.forEach((item) => {
            that.$set(that.subList, item.val, '');
            that.$set(that.subList, item.val + 't', '');
        });

        that.list2.forEach((item) => {
            that.$set(that.subList, item.val, '');
        });

        data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"))
        that.axios.post("/reservationInit", data).then(res => {
            if (res.data.code == 200) {
                console.log(res.data.sytime);
                that.questionnaire = res.data.questionnaire;
                if (res.data.sytime == '') {
                    that.isOrder = 1
                } else {
                    that.isOrder = 2
                }
                that.sytime = res.data.sytime;
                that.list = res.data.data;
            } else if (res.data.code == 280001) {
                that.toast(that.$t('meetingS.theme.query_tips_none'))
            }
        }).catch(err => {
            console.error(err);
        })
        //_hmt.push(['_trackPageview', '/meetingS/theme']);
    },
    mounted() {
    },
    methods: {
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path() {
            this.$router.replace('/menu')
        },
        setScore(index, index1) {
            this.$set(this.subList, index1, index);
        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        submit() {
            let that = this, data = new FormData();

            // 如果是第一阶段提交
            if (that.isOrder == 1) {
                if (that.sytime == '') {
                    that.toast(that.$t('meetingS.theme.query_tips'))
                    return;
                }

                data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"))
                data.append("tid", that.list[that.list.map(item => item.title).indexOf(that.sytime)].id)

                that.axios.post("/reservation", data).then(res => {
                    if (res.data.code == 200) {
                        that.toast(that.$t('investigation1.submit_success'))
                        that.isOrder = 2;
                    } else {
                        that.toast(res.data.msg || that.$t('investigation1.submit_error'))
                    }
                }).catch(err => {
                    console.error(err);
                })
                return;
            }

            // 第二阶段提交（问卷）
            // 验证第一组问题
            for (let item of that.list1) {
                if (item.type == 'input') {
                    // 如果是输入类型的题目
                    if (!that.subList[item.val] || !that.subList[item.val].trim()) {
                        that.toast(item.name, { name: item.name })
                        return;
                    }
                } else {
                    // 如果是评分类型的题目
                    if (!that.subList[item.val]) {
                        that.toast(that.$t('investigation1.required_tip', { name: item.name }))
                        return;
                    }
                    // 如果评分小于6分，需要填写原因
                    if (that.subList[item.val] > 0 && that.subList[item.val] < 6 && !that.subList[item.val + 't']) {
                        that.toast(that.$t('investigation1.reason_required_tip', { name: item.name }))
                        return;
                    }
                }
            }

            // 验证第二组问题
            for (let item of that.list2) {
                if (item.type == 'input') {
                    // 如果是输入类型的题目
                    if (!that.subList[item.val] || !that.subList[item.val].trim()) {
                        that.toast(item.name, { name: item.name })
                        return;
                    }
                } else {
                    // 如果是评分类型的题目
                    if (!that.subList[item.val]) {
                        that.toast(that.$t('investigation1.required_tip', { name: item.name }))
                        return;
                    }
                    // 如果评分小于6分，需要填写原因
                    if (that.subList[item.val] > 0 && that.subList[item.val] < 6 && !that.subList[item.val + 't']) {
                        that.toast(that.$t('investigation1.reason_required_tip', { name: item.name }))
                        return;
                    }
                }
            }

            // 验证问题3（建议）
            if (!that.subList.q13.trim()) {
                that.toast(that.$t('investigation1.suggestion_required'))
                return;
            }

            // 修改提交数据的准备部分
            data.append('uid', localStorage.getItem("nissan2023_meeting_uuid"))

            // 遍历第一组问题的答案
            that.list1.forEach(item => {
                data.append(item.val, that.subList[item.val] || '')
                // 如果有低分原因，也添加进去
                if (that.subList[item.val] > 0 && that.subList[item.val] < 6) {
                    data.append(item.val + 't', that.subList[item.val + 't'] || '')
                }
            });

            // 遍历第二组问题的答案
            that.list2.forEach(item => {
                data.append(item.val, that.subList[item.val] || '')
                // 如果有低分原因，也添加进去
                if (that.subList[item.val] > 0 && that.subList[item.val] < 6) {
                    data.append(item.val + 't', that.subList[item.val + 't'] || '')
                }
            });

            // 添加建议答案
            data.append('q13', that.subList.q13 || '')

            that.axios.post("/questionnaire2", data).then(res => {
                if (res.data.code == 200) {
                    that.toast(that.$t('investigation1.submit_success'))
                    setTimeout(() => {
                        that.$router.replace('/menu')
                    }, 1500)
                } else {
                    that.toast(res.data.msg || that.$t('investigation1.submit_error'))
                }
            }).catch(err => {
                console.error(err);
                that.toast(that.$t('investigation1.submit_error'))
            })
        }
    }
}
</script>
<style scoped>
.toast {
    padding: 0 .3rem;
}

.mainBody {
    min-height: 1rem;
}

#submit {
    padding: .2rem .5rem;
    width: 140px;
    text-align: center;
    background-color: #17aba2;
    color: #FFF;
    line-height: 13px;
    cursor: pointer;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
    font-size: .3rem;
}

.center {
    padding-bottom: .5rem;
}

.map {
    width: 100%;
    display: block;

}

.toast {
    padding: 0 .6rem;
}

.list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    font-size: .3rem;
    margin-bottom: .3rem;
}

.list1 {
    margin: .5rem 0;
    padding: 0 1.5rem;
    font-size: .35rem;
    text-align: center;
    font-weight: bold
}

.list1 img {
    width: 100%;
    margin-bottom: .15rem;
    opacity: .9;
}

.item {
    width: 47%;
    padding: .2rem 0;
    /* height: .7rem; */
    border-radius: .1rem;
    border: 1px solid #fff;
    margin-bottom: .1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
}

.item input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 999;
}

.active {
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/radio_bg.png) no-repeat;
    background-size: 100% 100%;
    color: #0b8383;
    font-weight: bold;
}

.active1 {
    border: 1px solid rgba(238, 238, 238, .5);
    background: rgba(238, 238, 238, .5);
    color: #777;
}

.bold {
    font-weight: bold;
    letter-spacing: .01rem;
}


input::-webkit-input-placeholder {
    color: #ccc;
}

input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
}

input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
}

input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ccc;
}

input[type="text"] {
    -webkit-appearance: none !important;
}

textarea {
    -webkit-appearance: none !important;
}

input {
    -webkit-appearance: none !important;
}


input[type="button"],
input[type="submit"],
input[type="reset"] {
    -webkit-appearance: none !important;
}

input[type='radio'],
input[type='checkbox'] {
    width: .26rem;
    height: .26rem;
    appearance: none;
    -webkit-appearance: none;
    transform: translateZ(1px);
    border-radius: 0;
}

input[type='radio'],
input[type='checkbox'] {
    background: url('https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/radio_check.png') no-repeat;
    background-size: .26rem .26rem;
    transform: translateZ(0);
}

input[type='radio']:checked,
input[type='checkbox']:checked {
    background: url('https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/radio_checkd.png') no-repeat;
    background-size: .26rem .26rem;
    transform: translateZ(0);
}

textarea,
input[type="text"] {
    -webkit-appearance: none;
}


.question {
    padding-bottom: .4rem;
}

.question>p:last-child {
    padding-top: .1rem;
    display: flex;
    justify-content: space-between;
}

.question>p:last-child>label {
    padding-right: .3rem;
    display: flex;
    align-items: center;
    line-height: 1;
}

.question>p:last-child>label>input {
    margin-right: .1rem;
}

.question_en {
    padding-bottom: .3rem;
}

.question_en>p:last-child {
    padding-top: .1rem;
    display: flex;
    flex-direction: column;
}

.question_en>p:last-child>label {
    padding-right: .7rem;
    display: flex;
    align-items: center;
    line-height: .4rem;
}

.question_en>p:last-child>label>input {
    margin-right: .1rem;
}

.star {
    width: 100%;
    justify-content: space-between;
    display: flex;
    align-items: center;
    height: .5rem;
    border: 1px solid #fff;
    border-right: none;
}

.star_tit {
    margin: .2rem 0 .1rem;
}

.star>label {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-right: 1px solid #fff;
}

.star>label>p {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.star>label>p.actives {
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/radio_bg.png) no-repeat;
    background-size: 100% 100%;
    color: #0b8383;
    font-weight: bold;
}

textarea {
    width: 100% !important;
    min-height: 1.5rem;
    padding: .12rem;
    font-size: .25rem;
    margin-bottom: .3rem;
    color: #0b8383;
}

input[type="button"] {
    min-height: .6rem !important;
    font-size: .28rem !important
}

textarea:focus {
    margin-bottom: .3rem;
}

textarea::-webkit-input-placeholder {
    color: #ccc;
}

.textarea_6 {
    margin-top: .3rem;
    margin-bottom: 0;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/meetingS/theme.vue